<template>
  <v-layout>
    <v-btn icon @click="handleShowForm">
      <v-icon small>fa-plus-circle</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card v-if="!caseInfo">
        Loading...
      </v-card>
      <v-card v-else>
        <v-card-title class="headline">Add service item</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <service-select v-model="form.serviceId"
                            :rules="serviceRules"
                            :serviceFilter="filterService"/>

            <div>
              <date-time-input
                label="Requested occurred at"
                :required="true"
                v-model="form.requested.occurredAt"/>
            </div>

            <number-input v-model="form.requested.quantity"
                          label="Quantity"
                          :min-value="1"
                          :max-value="100"/>

            <amount-input v-model="form.requested.price"
                          label="Price"
                          :nullable="true"
                          :additional-rules="priceRules"/>

            <v-text-field
              label="Comment"
              v-model="form.requested.comment"/>


            <v-checkbox label="Create executed" v-model="form.createExecuted"/>
            <div v-if="form.createExecuted">
              <date-time-input
                label="Executed occurred at"
                :required="true"
                v-model="form.executed.occurredAt"
                :min-datetime="form.requested.occurredAt"/>

              <number-input v-model="form.executed.quantity"
                            label="ExecutedQuantity"
                            :min-value="1"
                            :max-value="form.requested.quantity"/>

              <v-text-field
                label="Comment"
                v-model="form.executed.comment"/>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
    import ServiceSelect from '../../Ui/mcc/ServiceSelect'
    import NumberInput from '../../Ui/NumberInput'
    import AmountInput from "../../Ui/AmountInput";
    import {notNullFactory, positiveFactory} from "../../../validation/rules";
    import {mapActions} from "vuex";
    import {notificationService} from "../../../application";
    import {getDefaultExecutedDate, getDefaultRequestedDate} from './caseServiceLogUtils'
    import DateTimeInput from "../../Ui/DateTimeInput";

    function getDefaultFormData(caseInfo) {
        let requestedOccurredAt = getDefaultRequestedDate(caseInfo);
        let executedOccurredAt = getDefaultExecutedDate(caseInfo);

        return {
            serviceId: null,
            requested: {
                quantity: 1,
                occurredAt: requestedOccurredAt,
                comment: '',
                price: null
            },
            executed: {
                quantity: 1,
                occurredAt: executedOccurredAt,
                comment: ''
            },
            createExecuted: false,
        }
    }

    export default {
        name: 'add-case-service-form',
        components: {
            ServiceSelect,
            NumberInput,
            AmountInput,
            DateTimeInput
        },
        props: {
            caseId: {
                type: String,
                required: true
            },
            addedServices: { // for skip services duplicates
                type: Array,
                required: true
            }
        },
        data() {
            let caseInfo = this.$store.getters.getCaseInfoById(this.caseId); // computed not active, so copy-paste
            return {
                form: getDefaultFormData(caseInfo),
                showModal: false,
                isValid: false,
                serviceRules: [notNullFactory()],
                priceRules: [positiveFactory()]
            }
        },
        computed: {
            caseInfo() {
                return this.$store.getters.getCaseInfoById(this.caseId);
            },
            availableServicesForClient() {
                if (!this.caseInfo || !this.caseInfo.response) { // case not loaded yet
                    return []
                }

                return this.$store.getters.getClientServicesNotHidden(this.caseInfo.response.clientId);
            }
        },
        mounted() {
            this.fetchCaseByIdIfRequired(this.caseId);
            this.fetchInitDataIfRequired()
        },
        watch: {
            showModal() {
                if (!this.showModal) {
                    this.resetForm()
                }
            },
            caseInfo() {
                this.form.requested.occurredAt = getDefaultRequestedDate(this.caseInfo);
                this.form.executed.occurredAt = getDefaultExecutedDate(this.caseInfo);
            }
        },
        methods: {
            ...mapActions({
                addCaseService: 'addCaseService',
                fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired',
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            }),
            handleShowForm() {
                this.showModal = true
            },
            handleHideForm() {
                this.showModal = false
            },
            handleFormSubmit() {
                if (!this.$refs.form.validate()) {
                    return
                }

                // todo(TECH-325): validate

                let requested = {
                    quantity: this.form.requested.quantity,
                    comment: this.form.requested.comment,
                    occurredAt: this.form.requested.occurredAt,
                    price: this.form.requested.price
                };

                let executed = null;
                if (this.form.createExecuted) {
                    executed = {
                        quantity: this.form.executed.quantity,
                        comment: this.form.executed.comment,
                        occurredAt: this.form.executed.occurredAt
                    }
                }

                this
                    .addCaseService({
                        caseId: this.caseId,
                        serviceId: this.form.serviceId,
                        requested: requested,
                        executed: executed
                    })
                    .then(() => {
                        notificationService.info('Operation success');
                        this.resetForm();
                        this.showModal = false
                    })
                    .catch(e => {
                        notificationService.error('Operation failed');
                        throw e
                    })
            },
            resetForm() {
                this.form = getDefaultFormData(this.caseInfo)
            },
            filterService(service) {
                if (this.availableServicesForClient.indexOf(service.id) < 0) {
                    return false
                }

                if (this.addedServices.indexOf(service.id) > -1) { // already added
                    return false
                }

                return true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/AddCaseServiceForm.vue